import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ReduxToastr, { toastr } from 'react-redux-toastr';
import 'react-redux-toastr/lib/css/react-redux-toastr.min.css';
import { translate } from 'react-i18next';

import * as actions from '../redux/modules/notifyCenter';
import i18n from '../translations/i18n';

const propTypes = {
  t: PropTypes.func,
  notifications: PropTypes.any,
  clearNotifications: PropTypes.any,
};

class NotificationCenter extends React.Component {
  componentWillReceiveProps(nextProps) {
    const { successMessage, errorMessage } = nextProps.notifications;

    if (successMessage) {
      toastr.success(this.props.t('success'), successMessage);
      this.props.clearNotifications();
    }

    if (errorMessage) {
      toastr.error(this.props.t('error'), errorMessage);
      this.props.clearNotifications();
    }
  }

  render() {
    return <ReduxToastr />;
  }
}

NotificationCenter.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    notifications: state.notifyCenter,
  };
}

const extended = translate(['translations'], { i18n })(NotificationCenter);
export default connect(mapStateToProps, actions)(extended);



// WEBPACK FOOTER //
// ./src/containers/NotificationCenter.js